import React, { useState, useEffect } from "react";
import NavBar from '../components/NavBar';
import SectorSummary from '../components/SectorSummary';
import '../index';

function LandingPage() {
    const [sectors, setSectors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
        fetch("https://econ-dashboard-live.onrender.com/gics_data")
            .then(res => res.json())
            .then(data => {
                const formatted = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value
                }));
                setSectors(formatted);
                setLoading(false);
            })
            .catch(err => {
                setError("Server may be waking up...");
                setLoading(false);
            });
    }, []);
  
    return (
        <div>
            <NavBar sectors={sectors} />
            <main>
                {loading && sectors.length === 0 && <p>⏳ Loading data... (server may be waking up)</p>}
                {error && <p>{error}</p>}
                <div className="grid_list">
                    {sectors.map((sector) => (
                        <div key={sector.id}>
                            <a href={`/sector/${sector.id}`} style={{ color: "#fff", textDecoration: "none" }}>
                                <div className="card">
                                    <div style={{ height: "60px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                      <h3 style={{ color: "#000000", textDecoration: "none", fontWeight: "bold", margin: 0 }}>{sector.id}</h3>
                                    </div>
                                    <hr></hr>
                                    <SectorSummary sector={sector} />
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
}

export default LandingPage;